const harvestI = (callback, parent = false) =>
    ({ currentTarget }) => {
        const target = parent
            ? currentTarget.parentElement
            : currentTarget

        callback(target.getAttribute('i'))
    }

export default harvestI